import { View } from "ol";
import { Point } from "ol/geom";
import { fromLonLat } from "ol/proj";

export const buscadorLocalidades = (map) => {
  const buscador = document.querySelector("#buscador");
  const cancelar = document.querySelector("#buscador-cancelar-busqueda");

  buscador.addEventListener("keyup", async (e) => {
    if (e.target.value.length >= 3) {
      const res = await fetch(
        `https://api.ign.gob.ar/buscador/search?q=${e.target.value}&limit=5`
      );

      const jso = await res.json();

      const resultados = document.querySelector("#resultados");
      resultados.innerHTML = ""; //limpiar anterior
      resultados.style.display = "block";

      const ul = document.createElement("ul");

      jso.forEach((buscado) => {
        const li = document.createElement("li");
        li.textContent = `${buscado.place.name}, ${buscado.place.depto}, ${buscado.place.pcia} `;
        li.setAttribute("id", buscado.place.id);
        ul.appendChild(li);
      });

      resultados.appendChild(ul);

      //boton de cancelar
      cancelar.classList.add("mostrar");
      cancelar.addEventListener("click", (e) => {
        e.preventDefault();
        buscador.value = "";
        resultados.innerHTML = "";
        cancelar.classList.remove("mostrar");
        resultados.style.display = "none";
      });
    } else {
      const resultados = document.querySelector("#resultados");
      resultados.innerHTML = "";
      cancelar.classList.remove("mostrar");
    }
  });

  const resultados = document.querySelector("#resultados");

  resultados.addEventListener("click", async (e) => {
    buscador.value = "";
    if (e.target.tagName == "LI") {
      const li = e.target;
      const id = li.getAttribute("id");

      const res = await fetch(
        `https://api.ign.gob.ar/buscador/places?id=${id}&format=geojson`
      );
      const jso = await res.json();
      const point = new Point(fromLonLat(jso.features[0].geometry.coordinates));

      map.setView(
        new View({
          center: point.getCoordinates(),
          zoom: 14,
        })
      );

      //solucion rapida: al hacer click que se limpie la lista
      const resultados = document.querySelector("#resultados");
      resultados.innerHTML = ""; //limpiar anterior
      resultados.style.display = "none";
    }
  });
};
